import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component - Only scrolls for specific routes
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Only scroll to top for these specific routes (not back button navigation)
    const shouldScrollToTop =
      pathname.startsWith('/shop/product/') ||  // Product detail pages
      pathname === '/shop' ||                   // Shop category page
      pathname.startsWith('/shop?category=');   // Shop with category filter

    if (shouldScrollToTop) {
      // Use setTimeout to ensure the page has rendered
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'auto'  // Use 'auto' instead of 'smooth' for instant scroll
        });
      }, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;